import { StyledPromoLabel } from "./styles";

export const PromoLabel = ({ children }) => {
  return <StyledPromoLabel>{children}</StyledPromoLabel>;
};
